<ng-container *msShowInEpcot="{ showInEpcot: false, module: module }">
    <div class="alert__marker"></div>
    <div class="alert__content">
        <div class="alert__icon" [ngClass]="getIcon(type)"></div>
        <bs-alert-content [message]="message" [title]="title"></bs-alert-content>
    </div>
</ng-container>

<ng-container *msShowInEpcot="{ showInEpcot: true, module: module }">
    <div class="alert__content">
        <div class="alert__icon" [ngClass]="getIcon(type)"></div>
        <bs-alert-content [message]="message"></bs-alert-content>
    </div>
</ng-container>
